// src/hooks/useRevenueApi.js
//
// Phase 5 Revenue Intelligence data client. Demo accounts run against the
// separate demo backend (see services/demoApi.js) which exposes demo-safe
// shapes for the revenue endpoints instead of the real, spend-incurring
// ones. Every Revenue component resolves its client through this hook so the
// demo/production split lives in exactly one place.
import { useAuth } from "../contexts/AuthContext";
import apiService from "../services/api";

export default function useRevenueApi() {
  const { user } = useAuth();
  if (!user?.isDemo) return apiService;
  // Lazy-require the demo client so its separate axios instance (and the
  // demo base URL) is only pulled in when a demo account is actually in play.
  // eslint-disable-next-line global-require
  return require("../services/demoApi").default;
}
